import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import KlaroLogo from '@/components/haccp/KlaroLogo';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function InvitationAcceptPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState('loading');
  const [info, setInfo] = useState(null);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) { setState('invalid'); return; }
    fetch(`${BACKEND_URL}/api/invitations/lookup?token=${encodeURIComponent(token)}`)
      .then(r => r.ok ? r.json().then(d => { setInfo(d); setState('valid'); }) : setState('invalid'))
      .catch(() => setState('invalid'));
  }, [token]);

  const accept = async () => {
    if (password.length < 8) return toast.error('Password minimo 8 caratteri');
    if (password !== confirm) return toast.error('Le password non coincidono');
    setSubmitting(true);
    try {
      const r = await fetch(`${BACKEND_URL}/api/invitations/accept`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token, password }) });
      const data = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(data.detail || 'Attivazione non riuscita');
      toast.success('Account attivato');
      navigate('/login');
    } catch (e) { toast.error(e.message); } finally { setSubmitting(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="surface max-w-md w-full p-8">
        <KlaroLogo />
        {state === 'loading' && <p className="mt-6 text-sm text-[#475467] text-center">Caricamento invito…</p>}
        {state === 'invalid' && (<div className="text-center">
          <h1 className="mt-6 font-heading text-2xl font-semibold text-red-600">Invito non valido</h1>
          <p className="mt-2 text-sm text-[#475467]">Il link è scaduto o è già stato utilizzato.</p>
          <p className="mt-6 text-xs text-[#98A2B3]"><Link to="/login" className="hover:underline">← Torna al login</Link></p>
        </div>)}
        {state === 'valid' && info && (
          <div>
            <h1 className="mt-6 font-heading text-2xl font-semibold">Attiva il tuo account</h1>
            <p className="mt-2 text-sm text-[#475467]">Benvenuto in <strong>{info.company_name}</strong> come <strong>{info.role === 'admin' ? 'Amministratore' : 'Operatore'}</strong>.</p>
            <div className="mt-5 space-y-4">
              <div><Label>Email</Label><Input value={info.email} disabled /></div>
              <div><Label>Password (min. 8 caratteri) *</Label><Input data-testid="invitation-password" type="password" value={password} onChange={e => setPassword(e.target.value)} /></div>
              <div><Label>Conferma password *</Label><Input data-testid="invitation-confirm" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} /></div>
              <Button data-testid="invitation-accept-btn" variant="success" className="w-full" onClick={accept} disabled={submitting}>{submitting ? 'Attivazione…' : 'Attiva account'}</Button>
            </div>
            <p className="mt-6 text-center text-xs text-[#98A2B3]">Klaro non chiede mai la password via email.</p>
          </div>
        )}
      </div>
    </div>
  );
}
